export const googleAnalyticsIdUA =
  process.env.REACT_APP_GOOGLE_ANALYTICS_ID_UA || ''

export const googleAnalyticsIdGA4 = process.env.REACT_APP_GOOGLE_ANALYTICS_ID_GA4 || ''
